import React, { useState } from 'react';
import './MatchSummaryBox.css';
import constants from '../../../constants/constants';
import dateFormatter from '../../../generic actions/DateFormatter';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import BlockIcon from '@mui/icons-material/Block';
import * as matchActions from '../../../redux/actions/matchActions';
import { useDispatch } from 'react-redux';
import CustomModal from '../CustomModal/CustomModal';

function MatchSummaryBox({ match, showActions, isAdmin }) {
    const [showModal, setShowModal] = useState(false);
    const [modalInformation, setModalInformation] = useState({
        linkButtonText: constants.ADD_GAME.WAIT,
    });

    const dispatch = useDispatch();

    const handleApproveClickIcon = () => {
        setModalInformation({
            ...modalInformation,
            primaryButtonText: constants.ADD_GAME.APPROVED,
            action: constants.ADD_GAME.ACTION_APPROVE,
            title: constants.ADD_GAME.APPROVED,
        });
        setShowModal(true);
    };

    const handleRejectClickIcon = () => {
        setModalInformation({
            ...modalInformation,
            primaryButtonText: constants.ADD_GAME.REJECT,
            action: constants.ADD_GAME.ACTION_REJECT,
            title: constants.ADD_GAME.REJECT,
        });
        setShowModal(true);
    };

    const handleLinkButton = () => setShowModal(false);

    const handleDisableClickIcon = () => {
        setModalInformation({
            ...modalInformation,
            primaryButtonText: constants.ADD_GAME.DISABLE,
            action: constants.ADD_GAME.ACTION_DISABLE,
            title: constants.ADD_GAME.DISABLE,
        });
        setShowModal(true);
    };

    const handlePrimaryButton = async (action) => {
        if (action === constants.ADD_GAME.ACTION_DISABLE) {
            dispatch(matchActions.disableMatch(match.matchId));
        } else {
            dispatch(matchActions.approveOrRejectMatchByMatchId(match.matchId, action));
        }
        setShowModal(false);
    };

    const sortedSets = [...match.matchSets].sort((a, b) => Number(a.setNumber) - Number(b.setNumber));

    const p1Total = Number(match.playerOneScore);
    const p2Total = Number(match.playerTwoScore);
    const p1Won = p1Total > p2Total;

    const renderRow = (firstName, lastName, total, totalWon, isPlayerOne) => (
        <div className={`msb-player-row${totalWon ? ' msb-winner-row' : ''}`}>
            <div className={`msb-total${totalWon ? ' msb-total-winner' : ''}`}>{total}</div>
            <div className='msb-name'>{firstName} {lastName}</div>
            <div className='msb-sets'>
                {sortedSets.map((set) => {
                    const myScore = isPlayerOne ? set.playerOneScore : set.playerTwoScore;
                    const opScore = isPlayerOne ? set.playerTwoScore : set.playerOneScore;
                    const wonSet = Number(myScore) > Number(opScore);
                    return (
                        <span key={set.setNumber} className={`msb-set-score${wonSet ? ' msb-set-won' : ''}`}>
                            {myScore}
                        </span>
                    );
                })}
            </div>
        </div>
    );

    return (
        <div className='msb-container'>
            <div className='msb-date-label'>
                {dateFormatter(match.date)}, {match.courtName}
            </div>

            {sortedSets.length > 0 && (
                <div className='msb-header-row'>
                    <div className='msb-total' />
                    <div className='msb-name' />
                    <div className='msb-sets'>
                        {sortedSets.map((set) => (
                            <span key={set.setNumber} className='msb-set-header'>S{set.setNumber}</span>
                        ))}
                    </div>
                </div>
            )}

            {renderRow(match.playerOneFirstName, match.playerOneLastName, p1Total, p1Won, true)}
            {renderRow(match.playerTwoFirstName, match.playerTwoLastName, p2Total, !p1Won, false)}

            {showActions && (
                <div className='msb-actions'>
                    <button className='msb-action-btn msb-action-approve' onClick={handleApproveClickIcon}>
                        <CheckCircleOutlineIcon fontSize='small' />
                        {constants.ADD_GAME.APPROVED}
                    </button>
                    <button className='msb-action-btn msb-action-reject' onClick={handleRejectClickIcon}>
                        <HighlightOffIcon fontSize='small' />
                        {constants.ADD_GAME.REJECT}
                    </button>
                </div>
            )}
            {isAdmin && (
                <div className='msb-admin-actions'>
                    <button className='msb-action-btn msb-action-disable' onClick={handleDisableClickIcon}>
                        <BlockIcon fontSize='small' />
                        {constants.ADD_GAME.DISABLE}
                    </button>
                </div>
            )}

            {showModal && (
                <CustomModal
                    modalInformation={modalInformation}
                    handleLinkButton={handleLinkButton}
                    handlePrimaryButton={handlePrimaryButton}
                />
            )}
        </div>
    );
}

export default MatchSummaryBox;
